import * as Icons from '@ant-design/icons';
import React from 'react';
import { DOCUMENT_STATUSES_MAP } from './statuses-map';
import { DocumentRequirement } from './document-requirement';
import { DocumentStatuses } from 'interfaces/documentation/document';
import { TagField } from '@refinedev/antd';
import { Tooltip, Typography } from 'antd';
import { pluralize } from '../../../../utils/pluralize';

interface DocumentPanelHeaderProps {
  title: string;
  status: DocumentStatuses;
  requirement: DocumentRequirement;
  document_count: number;
}

interface RequirementTag {
  color: string;
  label: string;
  tooltip?: string;
}

const REQUIREMENT_TAGS: Record<DocumentRequirement, RequirementTag> = {
  required: { color: 'red', label: 'Obrigatório' },
  optional: { color: 'gold', label: 'Opcional' },
  waived_by_cin: {
    color: 'green',
    label: 'Dispensado: CIN',
    tooltip:
      'O aluno enviou a Carteira de Identidade Nacional, já aprovada. O número da CIN é o CPF, então este documento não é exigido.'
  },
  waivable_by_cin: {
    color: 'orange',
    label: 'Dispensado se a CIN for aprovada',
    tooltip:
      'O aluno enviou a Carteira de Identidade Nacional, cujo número é o CPF. Aprovada a CIN, este documento deixa de ser exigido; recusada, volta a ser obrigatório.'
  }
};

export const DocumentPanelHeader = ({
  title,
  status,
  requirement,
  document_count
}: DocumentPanelHeaderProps) => {
  const documentStatus = DOCUMENT_STATUSES_MAP[status];
  const IconComponent = documentStatus?.icon ?? <Icons.CheckCircleOutlined />;
  const color = documentStatus?.color;
  const requirementTag = REQUIREMENT_TAGS[requirement];

  return (
    <div className="w-full flex items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <div className="flex items-center" style={{ color }}>
          {IconComponent}
        </div>
        <Typography.Text strong>{title}</Typography.Text>
        <TagField
          color={document_count === 0 ? 'default' : 'blue'}
          value={
            document_count === 0
              ? 'Documentos não enviados'
              : `${pluralize(document_count, 'documento', 'documentos')}`
          }
        />
      </div>
      <Tooltip title={requirementTag.tooltip}>
        <span>
          <TagField
            style={{ margin: 0, border: 0 }}
            color={requirementTag.color}
            value={requirementTag.label}
          />
        </span>
      </Tooltip>
    </div>
  );
};
